var modLeadEmail = function(){
    var scope = ".js-mod-lead-email";
    ui.ready(
        scope,
        function($mod){
            var $message = $mod.find(scope+"__message");
            $message.hide();
            var $loginForm = $mod.find(scope+"__form");
            $loginForm.submit(
                function(ev){
                    ev.preventDefault();
                    var $confirmButton = $loginForm.find(scope+"__confirm");
                    var isOk = $loginForm.checkRestrictions();
                    if(isOk){
                        $confirmButton.prop("disabled",true);
                        gvf.endpoint(
                            "web\\webUserController::confirmLeadEmail",
                            [$loginForm.getValues()],
                            function(response){
                                if(response.status=="ok"){
                                    $loginForm.hide();
                                    $message.show();
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }
                }
            );
        }
    );
}();
